<section class="container">
  <div class="row justify-content-end">
    <em class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover m-3" (click)="activeModal.dismiss('Cross click')"></em>
  </div>
  <div class="row">
    <img src="{{imageUrl()}}" alt="{{alt()}}">
  </div>
</section>
